import { Box, Tabs, Tab } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CustomTabPanel = (props) => {
  const { children, value, index, styles } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      <Box sx={styles ?? { p: 3 }}>{children}</Box>
    </div>
  );
}

export const ContentHeaderTabs = styled(Tabs)({
  "& .MuiTabs-indicator": {
    backgroundColor: "#0E2465",
    height: "5px"
  },
});

export const HeaderTab = styled(Tab, {
  shouldForwardProp: (prop) => prop !== 'sx' && prop !== 'customWidth',
})(({ theme, sx }) => {
  const customWidth = sx && typeof sx === 'object' && 'width' in sx
    ? sx.width
    : `${100 / 3}%`;

  return {
    textTransform: "none",
    minWidth: 0,
    [theme.breakpoints.up("sm")]: {
      minWidth: 0,
    },
    fontWeight: theme.typography.fontWeightRegular,
    borderBottom: "5px solid #F6F9FF",
    padding: "1rem",
    width: customWidth,
    maxWidth: `${customWidth} !important`,
    color: "#0E2465",
    "&:hover": {
      color: "#0E2465",
      opacity: 1,
    },
    "&.Mui-selected": {
      color: "#0E2465",
      fontWeight: theme.typography.fontWeightMedium,
    },
    "&.Mui-focusVisible": {
      backgroundColor: "#d1eaff",
    },
    ...(sx && typeof sx === 'object' ? sx : {}),
  };
});
